"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPolicyProjectTypeLabel = void 0;
const contracts_1 = require("./contracts");
const getPolicyProjectTypeLabel = (type) => {
    switch (type) {
        case contracts_1.PolicyProjectType.TRAVEL_POLICY_PROJECT:
            return "Travel Policy";
        case contracts_1.PolicyProjectType.LEAVE_POLICY_PROJECT:
            return "Leave Policy";
        case contracts_1.PolicyProjectType.CUSTOM_POLICY_PROJECT:
            return "Custom Policy";
        case contracts_1.PolicyProjectType.DIVERSITY_INCLUSION_POLICY_PROJECT:
            return "Diversity and Inclusion Policy";
        case contracts_1.PolicyProjectType.REMOTE_WORK_POLICY_PROJECT:
            return "Remote Work Policy";
        case contracts_1.PolicyProjectType.PERFORMANCE_EVALUATION_POLICY_PROJECT:
            return "Performance Evaluation Policy";
        case contracts_1.PolicyProjectType.EMPLOYEE_BENEFITS_POLICY_PROJECT:
            return "Employee Benefits Policy";
        case contracts_1.PolicyProjectType.SALARY_COMPENSATION_POLICY_PROJECT:
            return "Salary and Compensation Policy";
        case contracts_1.PolicyProjectType.OVERTIME_POLICY_PROJECT:
            return "Overtime Policy";
        case contracts_1.PolicyProjectType.SEXUAL_HARASSMENT_POLICY_PROJECT:
            return "Sexual Harassment Policy";
        case contracts_1.PolicyProjectType.NON_DISCRIMINATION_POLICY_PROJECT:
            return "Non-Discrimination Policy";
        case contracts_1.PolicyProjectType.WORKPLACE_HARASSMENT_POLICY_PROJECT:
            return "Workplace Harassment Policy";
        case contracts_1.PolicyProjectType.PARENTAL_LEAVE_POLICY_PROJECT:
            return "Parental Leave Policy";
        case contracts_1.PolicyProjectType.TERMINATION_POLICY_PROJECT:
            return "Termination Policy";
        case contracts_1.PolicyProjectType.WHISTLEBLOWER_PROTECTION_POLICY_PROJECT:
            return "Whistleblower Protection Policy";
        case contracts_1.PolicyProjectType.VACATION_HOLIDAY_POLICY_PROJECT:
            return "Vacation and Holiday Policy";
        case contracts_1.PolicyProjectType.MATERNITY_LEAVE_POLICY_PROJECT:
            return "Maternity Leave Policy";
        case contracts_1.PolicyProjectType.WORK_LIFE_BALANCE_POLICY_PROJECT:
            return "Work-Life Balance Policy";
        case contracts_1.PolicyProjectType.SICK_LEAVE_POLICY_PROJECT:
            return "Sick Leave Policy";
        case contracts_1.PolicyProjectType.HEALTH_SAFETY_POLICY_PROJECT:
            return "Health and Safety Policy";
        case contracts_1.PolicyProjectType.EXPENSE_REIMBURSEMENT_POLICY_PROJECT:
            return "Expense Reimbursement Policy";
        case contracts_1.PolicyProjectType.EQUAL_EMPLOYMENT_OPPORTUNITY_POLICY_PROJECT:
            return "Equal Employment Opportunity Policy";
        default:
            return type;
    }
};
exports.getPolicyProjectTypeLabel = getPolicyProjectTypeLabel;
